import * as Sentry from '@sentry/browser';
import { IsLocalHost } from './isLocalHost';

type Args = {
  title: string;
  error?: any;
  detail?: Record<string, any>;
};

export const captureSentry = ({ title, error, detail }: Args) => {
  if (IsLocalHost() && import.meta.env.VITE_SIMULATION !== 'true') {
    alert(`Sentry Error: ${title} ${JSON.stringify(error)} ${JSON.stringify(detail)}`);
  }
  Sentry.setContext('Title', {
    title: title,
  });
  console.error(`Sentry Error:`, title, error, detail);
  if (detail && typeof detail === 'object') {
    const stringifiedDetail = JSON.stringify(detail, (_, value) => {
      if (typeof value === 'bigint') {
        return value.toString();
      } else if (typeof value === 'function') {
        return value.toString();
      } else {
        return value;
      }
    });

    console.warn('Sentry Detail:', stringifiedDetail);
    Sentry.setContext('Error Detail', { detail: stringifiedDetail });
  }
  if (error) {
    Sentry.captureException(error);
  } else Sentry.captureMessage(title);
};
